<template>
  <iframe :src="webUrl+'/admin/platform/system.set'"></iframe>
</template>

<script>
export default {
  name: "plant",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>